import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  display: flex;
`;
export const IconWallet = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            const group = wrapper?.querySelector('g');
            if (!group) {
                return;
            }
            gsap.to(group, {
                keyframes: [
                    {
                        '--wallet-skew': '0deg',
                        '--wallet-scale': 1,
                        duration: 0.2,
                    },
                    {
                        '--wallet-skew': '10deg',
                        '--wallet-scale': 0.825,
                        duration: 0.3,
                        delay: 0.1,
                        onComplete: triggerDone,
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Wallet, null)));
};
//# sourceMappingURL=Wallet.js.map